/* tslint:disable:max-line-length */
import React from 'react';
import classNames from 'classnames';
import { IconTypeProps } from '../types';

type Props = IconTypeProps & {
  expand: boolean;
  size?: number;
};

export const ExpandIcon = ({
  className,
  color = '#312D4A',
  onClick,
  expand,
  size = 16,
}: Props) => {
  const degree = expand ? 45 : 0;
  const style = {
    transform: `rotate(${degree}deg)`,
    transition: '.2s',
    width: `${size}px`,
    height: `${size}px`,
  };

  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M15.6667 7H9V0.333333C9 0.149167 8.85083 0 8.66667 0H7.33333C7.14917 0 7 0.149167 7 0.333333V7H0.333333C0.149167 7 0 7.14917 0 7.33333V8.66667C0 8.85083 0.149167 9 0.333333 9H7V15.6667C7 15.8508 7.14917 16 7.33333 16H8.66667C8.85083 16 9 15.8508 9 15.6667V9H15.6667C15.8508 9 16 8.85083 16 8.66667V7.33333C16 7.14917 15.8508 7 15.6667 7Z"
        fill={color}
      />
    </svg>
  );
};
